var PES = PES || {};

PES.SectionValidationModel = function (model) {

    var self = this;

    // Enable use of validationOptions ko object in order to apply custom invalid classes to the input elements
    ko.validation.configuration.decorateInputElement = true; 

    self.generalErrors = ko.observableArray([]);
    self.generalCriticalErrors = ko.observableArray([]);
    self.validationOptions = {
        decorateInputElement: true,
        errorElementClass: 'error-element',
        errorMessageClass: 'error-message'
    };
    self.errors = ko.validation.group(model, { deep: true });
    self.isValidating = ko.observable(false);
    self.hasBeenValidated = ko.observable(false);
    self.errorTitle = ko.observable("");
    self.errorContent = ko.observable("");
    self.errorSmallContent = ko.observable("");
    self.criticalErrorTitle = ko.observable("");
    self.criticalErrorContent = ko.observable("");
    self.criticalErrorSmallContent = ko.observable("");
    self.note = ko.observable("");

    self.hasCustomError = ko.computed(function () {
        return self.errorTitle() ||
            self.errorContent() ||
            self.errorSmallContent();
    });

    self.hasCustomCriticalError = ko.computed(function () {
        return self.criticalErrorTitle() ||
            self.criticalErrorContent() ||
            self.criticalErrorSmallContent();
    });

    self.isValid = ko.computed(function () {
        return self.errors().length === 0;
    });

    self.canValidate = ko.computed(function () {
        return self.isValid() && !self.isValidating();
    });

    self.cleanErrors = function () {
        self.criticalErrorTitle(null);
        self.criticalErrorContent(null);
        self.criticalErrorSmallContent(null);
        self.errorTitle(null);
        self.errorContent(null);
        self.errorSmallContent(null);
        self.generalErrors.removeAll();
        self.generalCriticalErrors.removeAll();
        self.errors = ko.validation.group(model, { deep: true });
    };

    self.cleanGeneralErrors = function () {
        self.generalErrors.removeAll();
        self.generalCriticalErrors.removeAll();
        self.errors = ko.validation.group(model, { deep: true });
    };
};



